import { observer } from 'mobx-react-lite';
import React, { CSSProperties } from 'react';
import { ThemeProvider } from 'styled-components';
import { themeState } from 'styleguide/theme';

interface SvgProps {
  tint?: string;
  style?: CSSProperties;
}

function SvgSettings(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.5 12C8.5 10.0665 10.0665 8.5 12 8.5C13.9335 8.5 15.5 10.0665 15.5 12C15.5 13.9335 13.9335 15.5 12 15.5C10.0665 15.5 8.5 13.9335 8.5 12Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.1958 9.6216L20.3115 10.3663C19.3018 11.2117 19.3018 12.7883 20.3115 13.6337L21.1958 14.3784C21.5125 14.6401 21.5917 15.0963 21.3871 15.4586L19.6384 18.5448C19.4338 18.9004 19.0049 19.0614 18.6221 18.9138L17.5465 18.5045C16.3191 18.0349 14.9795 18.8266 14.7617 20.1416L14.5703 21.2955C14.5043 21.7048 14.1546 22 13.752 22H10.248C9.83882 22 9.49567 21.6981 9.42968 21.2955L9.2383 20.1416C9.02054 18.8266 7.68093 18.0416 6.45351 18.5045L5.37787 18.9138C4.99513 19.0614 4.56619 18.9004 4.36162 18.5448L2.61288 15.4586C2.40831 15.103 2.48749 14.6468 2.80425 14.3784L3.68852 13.6337C4.69817 12.7883 4.69817 11.2117 3.68852 10.3663L2.80425 9.6216C2.48749 9.35995 2.40831 8.90372 2.61288 8.54143L4.36162 5.45522C4.56619 5.09963 4.99513 4.93861 5.37787 5.08621L6.45351 5.49547C7.68093 5.96511 9.02054 5.17343 9.2383 3.85844L9.42968 2.70446C9.49567 2.2952 9.84542 2 10.248 2H13.752C14.1612 2 14.5043 2.30191 14.5703 2.70446L14.7617 3.85844C14.9795 5.17343 16.3191 5.9584 17.5465 5.49547L18.6221 5.08621C19.0049 4.93861 19.4338 5.09963 19.6384 5.45522L21.3871 8.54143C21.5917 8.89701 21.5125 9.35324 21.1958 9.6216Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgLogout(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5 17L21.5 12M21.5 12L16.5 7M21.5 12H9.5M9.5 3H8.3C6.61984 3 5.77976 3 5.13803 3.32698C4.57354 3.6146 4.1146 4.07354 3.82698 4.63803C3.5 5.27976 3.5 6.11984 3.5 7.8V16.2C3.5 17.8802 3.5 18.7202 3.82698 19.362C4.1146 19.9265 4.57354 20.3854 5.13803 20.673C5.77976 21 6.61984 21 8.3 21H9.5"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgLock(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5 10.25V6.5C16.5 5.30653 16.0259 4.16193 15.182 3.31802C14.3381 2.47411 13.1935 2 12 2C10.8065 2 9.66193 2.47411 8.81802 3.31802C7.97411 4.16193 7.5 5.30653 7.5 6.5V10.25M6.75 22H17.25C17.8467 22 18.419 21.7629 18.841 21.341C19.2629 20.919 19.5 20.3467 19.5 19.75V12.5C19.5 11.9033 19.2629 11.331 18.841 10.909C18.419 10.4871 17.8467 10.25 17.25 10.25H6.75C6.15326 10.25 5.58097 10.4871 5.15901 10.909C4.73705 11.331 4.5 11.9033 4.5 12.5V19.75C4.5 20.3467 4.73705 20.919 5.15901 21.341C5.58097 21.7629 6.15326 22 6.75 22Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgRuler(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.8125 8L13.8125 6"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 15.8125L6 13.8125"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9063 11.9063L9.90625 9.90625"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.54176 21.7498C7.15124 22.1403 6.51807 22.1403 6.12755 21.7498L2.25008 17.8723C1.85955 17.4818 1.85955 16.8486 2.25008 16.4581L16.462 2.24617C16.8526 1.85564 17.4857 1.85564 17.8762 2.24617L21.7537 6.12364C22.1442 6.51417 22.1442 7.14733 21.7537 7.53786L7.54176 21.7498Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgExport(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.4697 12.4736C10.1768 12.7665 10.1768 13.2413 10.4697 13.5342C10.7626 13.8271 11.2374 13.8271 11.5303 13.5342L10.4697 12.4736ZM19.4697 3.47358L10.4697 12.4736L11.5303 13.5342L20.5303 4.53424L19.4697 3.47358Z"
        fill={props.tint}
      />
      <path
        d="M14 4L20 4L20 10"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 6H4C2.89543 6 2 6.89543 2 8V20C2 21.1046 2.89543 22 4 22H16C17.1046 22 18 21.1046 18 20V16"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

function SvgMoon(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.5457 13.6531C18.3729 16.1259 13.9366 15.8986 11.0184 12.9804C8.10021 10.0622 7.87294 5.62585 10.3457 2.45312C8.50021 2.80767 6.72749 3.54403 5.30021 4.97131C1.5093 8.76222 1.5093 14.9077 5.30021 18.6986C9.09112 22.4895 15.2366 22.4895 19.0275 18.6986C20.4548 17.2713 21.2002 15.4986 21.5457 13.6531Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgChevronDown(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 2L6 6L10 2"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgRoutine(props: SvgProps) {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.998 4h-1a3 3 0 00-3 3v11a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3h-1"
        stroke={props.tint}
        strokeWidth={1.5}
      />
      <path
        d="M16.002 15h-8m8-4h-8"
        stroke={props.tint}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x={8.002} y={2} width={8} height={4} rx={0.5} stroke={props.tint} strokeWidth={1.5} />
    </svg>
  );
}

function SvgCoach(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.54297 10.648C3.54297 9.10402 4.80129 7.8457 6.34524 7.8457C7.8892 7.8457 9.14752 9.10402 9.14752 10.648C9.14752 12.1919 7.8892 13.4503 6.34524 13.4503C4.80129 13.4503 3.54297 12.1919 3.54297 10.648Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M1.99609 21.0056L1.99609 16.3808C1.99609 14.9295 3.1695 13.7561 4.62081 13.7561H9.37619C9.84709 13.7561 10.318 13.8642 10.7349 14.0649C10.7349 14.0649 9.91657 13.6712 12.9273 15.1225L14.5175 13.6171C15.0425 13.1076 15.7681 13.1385 16.2622 13.6403C16.7331 14.1267 16.7254 14.8909 16.2391 15.3618L14.0312 17.477C13.6607 17.8399 13.0971 17.9325 12.6262 17.7086C9.24495 16.0798 10.2871 16.5815 10.0864 16.4812V20.9207"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M8.15076 5.92245V5.48294C8.15076 4.66371 8.81487 3.9996 9.63409 3.9996H20.5119C21.3311 3.9996 21.9952 4.66372 21.9952 5.48294V15.9762C21.9952 16.7954 21.3312 17.4595 20.512 17.4595C19.2915 17.4595 17.8666 17.4595 16.9958 17.4595"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}

function SvgHome(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 11V20C3 21.1046 3.89543 22 5 22H10V18M21 11V20C21 21.1046 20.1046 22 19 22H14V17.5"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M14 19L14 16C14 15.4477 13.5523 15 13 15L11 15C10.4477 15 10 15.4477 10 16L10 19"
        stroke={props.tint}
        strokeWidth="1.5"
      />
      <path
        d="M1 13L11.2929 2.70711C11.6834 2.31658 12.3166 2.31658 12.7071 2.70711L23 13"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

function SvgProfile(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 12C14.4853 12 16.5 9.98528 16.5 7.5C16.5 5.01472 14.4853 3 12 3C9.51472 3 7.5 5.01472 7.5 7.5C7.5 9.98528 9.51472 12 12 12Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 22C21 18.134 16.9706 15 12 15C7.02944 15 3 18.134 3 22"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

function SvgNewFolder(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.5 7l-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 00-.748-.462C10.6 3 10.24 3 9.522 3H5.7c-1.12 0-1.68 0-2.108.218a2 2 0 00-.874.874C2.5 4.52 2.5 5.08 2.5 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 011.311 1.311c.327.642.327 1.482.327 3.162v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 01-1.311 1.311C20.22 21 19.38 21 17.7 21H7.3c-1.68 0-2.52 0-3.162-.327a3 3 0 01-1.311-1.311C2.5 18.72 2.5 17.88 2.5 16.2V7zm10 10v-6m-3 3h6"
        stroke={props.tint}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgCamera(props: SvgProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M23.568 5.322a2.95 2.95 0 00-2.165-.897h-2.679l-.61-1.626c-.151-.39-.428-.728-.831-1.011-.403-.283-.816-.425-1.238-.425H9.92c-.423 0-.836.142-1.238.425-.403.283-.68.62-.832 1.01l-.61 1.627H4.562c-.845 0-1.567.3-2.165.897A2.95 2.95 0 001.5 7.487v10.717c0 .846.299 1.567.897 2.165a2.95 2.95 0 002.165.898h16.841c.845 0 1.567-.3 2.165-.898a2.95 2.95 0 00.897-2.165V7.487a2.95 2.95 0 00-.897-2.165zm-7.63 10.479c-.853.853-1.88 1.28-3.08 1.28-1.2 0-2.226-.427-3.079-1.28-.853-.853-1.279-1.88-1.279-3.08 0-1.2.427-2.225 1.28-3.078.852-.853 1.879-1.28 3.079-1.28 1.2 0 2.226.427 3.079 1.28.853.852 1.28 1.879 1.28 3.079 0 1.2-.427 2.226-1.28 3.079z"
        fillRule="nonzero"
        stroke={props.tint}
        strokeWidth={1.5}
        fill="none"
      />
    </svg>
  );
}

function SvgMenu(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 16H28M4 8H28M4 24H28"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgArrowLeft(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 12H4M4 12L11 19M4 12L11 5"
        stroke={props.tint}
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgLink(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.0903 14.3032L9.91177 15.4817C8.28459 17.1089 5.6464 17.1089 4.01922 15.4817C2.39203 13.8546 2.39203 11.2164 4.01922 9.58919L5.19773 8.41068M15.8043 9.58919L16.9828 8.41067C18.61 6.78349 18.61 4.1453 16.9828 2.51812C15.3557 0.890933 12.7175 0.890933 11.0903 2.51812L9.91177 3.69663M7.58436 11.9166L13.4177 6.08325"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgExercise(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.43125 14.704L14.2387 16.055C14.8568 16.1322 15.3208 16.6578 15.3208 17.2805C15.3208 18.0233 14.6694 18.5985 13.9325 18.5063L3.12502 17.1554C2.50697 17.0782 2.04297 16.5526 2.04297 15.9299C2.04297 15.187 2.69401 14.6119 3.43125 14.704Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.70312 17.2275V21.9992"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6602 18.4727V21.9995"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.15625 12.7135C2.15625 11.5676 3.08519 10.6387 4.23105 10.6387C5.3769 10.6387 6.30584 11.5676 6.30584 12.7135C6.30584 13.8593 5.3769 14.7883 4.23105 14.7883C3.08519 14.7883 2.15625 13.8593 2.15625 12.7135Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5858 9.25226V13.2867V12.3792L18.1186 13.1958C19.3644 13.3514 20.2995 14.4108 20.2995 15.6662V20.7556C20.2995 21.4431 19.7422 22.0004 19.0547 22.0004C18.3673 22.0004 17.8099 21.4431 17.8099 20.7556V16.5024L7.64535 15.2317C6.81475 15.1278 6.19141 14.422 6.19141 13.5848C6.19141 12.5865 7.0662 11.8141 8.05707 11.938L9.09618 12.0677V9.25195"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.60547 5.73445C6.60547 3.6721 8.27757 2 10.3399 2C12.4023 2 14.0744 3.6721 14.0744 5.73445C14.0744 7.7968 12.4023 9.46889 10.3399 9.46889C8.27757 9.46889 6.60547 7.7968 6.60547 5.73445Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.09766 5.73407C9.09766 5.04662 9.65502 4.48926 10.3425 4.48926C11.0299 4.48926 11.5873 5.04662 11.5873 5.73407C11.5873 6.42152 11.0299 6.97889 10.3425 6.97889C9.65502 6.97889 9.09766 6.42152 9.09766 5.73407Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 22H22.0001"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgBarChart(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.25 15H5.75C5.04993 15 4.6999 15 4.43251 15.1362C4.19731 15.2561 4.00608 15.4473 3.88624 15.6825C3.75 15.9499 3.75 16.2999 3.75 17V24.25C3.75 24.9501 3.75 25.3001 3.88624 25.5675C4.00608 25.8027 4.19731 25.9939 4.43251 26.1138C4.6999 26.25 5.04993 26.25 5.75 26.25H11.25M11.25 26.25H18.75M11.25 26.25L11.25 10.75C11.25 10.0499 11.25 9.6999 11.3862 9.43251C11.5061 9.19731 11.6973 9.00608 11.9325 8.88624C12.1999 8.75 12.5499 8.75 13.25 8.75H16.75C17.4501 8.75 17.8001 8.75 18.0675 8.88624C18.3027 9.00608 18.4939 9.19731 18.6138 9.43251C18.75 9.6999 18.75 10.0499 18.75 10.75V26.25M18.75 26.25H24.25C24.9501 26.25 25.3001 26.25 25.5675 26.1138C25.8027 25.9939 25.9939 25.8027 26.1138 25.5675C26.25 25.3001 26.25 24.9501 26.25 24.25V5.75C26.25 5.04993 26.25 4.6999 26.1138 4.43251C25.9939 4.19731 25.8027 4.00608 25.5675 3.88624C25.3001 3.75 24.9501 3.75 24.25 3.75H20.75C20.0499 3.75 19.6999 3.75 19.4325 3.88624C19.1973 4.00608 19.0061 4.19731 18.8862 4.43251C18.75 4.6999 18.75 5.04993 18.75 5.75V10"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgDeveloper(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 18V6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V18"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 21H4.5C2.73372 21 1.27713 19.693 1.03527 17.9985C0.996251 17.7251 1.22386 17.5 1.5 17.5H22.5C22.7761 17.5 23.0038 17.7251 22.9648 17.9985C22.7226 19.6976 21.261 21 19.5 21Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 13L17 11L15.5 9"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 13L7 11L8.5 9"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 14L13 8"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgBeginner(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="3"
        y="12"
        width="4"
        height="9"
        rx="1"
        fill={props.tint}
        stroke={props.tint}
        strokeWidth="1.5"
      />
      <rect x="10" y="7" width="4" height="14" rx="1" stroke={props.tint} strokeWidth="1.5" />
      <rect x="17" y="3" width="4" height="18" rx="1" stroke={props.tint} strokeWidth="1.5" />
    </svg>
  );
}

function SvgIntermediate(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="3"
        y="12"
        width="4"
        height="9"
        rx="0.5"
        fill={props.tint}
        stroke={props.tint}
        strokeWidth="1.5"
      />
      <rect
        x="10"
        y="7"
        width="4"
        height="14"
        rx="0.5"
        fill={props.tint}
        stroke={props.tint}
        strokeWidth="1.5"
      />
      <rect x="17" y="3" width="4" height="18" rx="0.5" stroke={props.tint} strokeWidth="1.5" />
    </svg>
  );
}

function SvgAdvanced(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="3"
        y="12"
        width="4"
        height="9"
        rx="0.5"
        fill={props.tint}
        stroke={props.tint}
        strokeWidth="1.5"
      />
      <rect
        x="10"
        y="7"
        width="4"
        height="14"
        rx="0.5"
        fill={props.tint}
        stroke={props.tint}
        strokeWidth="1.5"
      />
      <rect
        x="17"
        y="3"
        width="4"
        height="18"
        rx="0.5"
        fill={props.tint}
        stroke={props.tint}
        strokeWidth="1.5"
      />
    </svg>
  );
}

function SvgMuscle(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.0003 22H6.69363C4.66105 20.8333 0.93464 17.6333 2.2897 14.1666C3.64475 10.7 5.67741 6.49996 6.52435 4.83329C7.06133 3.99671 9.51341 2.7065 10.5077 2.2072C10.7715 2.07473 11.0811 2.08553 11.3377 2.23152C11.9533 2.58184 13.1489 3.27065 14.1216 3.88176C14.4794 4.10653 14.6225 4.55246 14.4742 4.94807L13.6981 7.01747C13.516 7.50298 12.9654 7.73811 12.4888 7.53385L11.2464 7.00141C10.7046 6.7692 10.0885 7.1061 9.99156 7.68755L8.81829 14.7272C10.9283 11.9997 16.0911 11.9997 18.3639 14.7272C18.3639 14.7272 19.7276 12.4547 21.5458 12"
        stroke={props.tint}
        strokeWidth="1.36366"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgScale(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.51675 5.44502C1.24468 3.63121 2.64946 2 4.48356 2H19.5164C21.3505 2 22.7553 3.63121 22.4832 5.44502L20.3832 19.445C20.163 20.9136 18.9014 22 17.4164 22H6.58356C5.09857 22 3.83704 20.9136 3.61675 19.445L1.51675 5.44502Z"
        stroke={props.tint}
        strokeWidth="1.5"
      />
      <path
        d="M5.85564 7.04988C6.84516 8.36659 7.83469 9.6833 8.82422 11C9.76586 10.2938 10.8871 9.93866 12.0043 9.93866C13.1215 9.93866 14.2427 10.2938 15.1843 11L18.0002 7.04951C14.3533 4.31634 9.50252 4.31671 5.85564 7.04988Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9.79687V7.79688"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgMachine(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 19V23M9 23V19"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeMiterlimit="13.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 16V4C9 3.44772 9.44772 3 10 3H15C15.5523 3 16 3.44772 16 4V15.9956"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeMiterlimit="13.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 8L19.9527 5H4.05209L2 8"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeMiterlimit="13.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 5V1"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeMiterlimit="13.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 18C7 16.8954 7.89543 16 9 16H16C17.1046 16 18 16.8954 18 18V19H7V18Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M5 23H21"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeMiterlimit="13.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgBody(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 7.5H8.76747C8.27339 7.5 7.79679 7.68289 7.42954 8.01341L3.89857 11.1913C3.41013 11.6309 3.39017 12.3902 3.85483 12.8548V12.8548C4.23248 13.2325 4.82082 13.2995 5.27373 13.0164L8.35069 11.0933C8.4165 11.0522 8.50205 11.0984 8.50367 11.176L8.71651 21.3923C8.73512 22.2856 9.46459 23 10.3581 23V23C11.2649 23 12 22.2649 12 21.3581V15.5"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12 7.5H15.2325C15.7266 7.5 16.2032 7.68289 16.5705 8.01341L20.1014 11.1913C20.5899 11.6309 20.6098 12.3902 20.1452 12.8548V12.8548C19.7675 13.2325 19.1792 13.2995 18.7263 13.0164L15.6493 11.0933C15.5835 11.0522 15.4979 11.0984 15.4963 11.176L15.2835 21.3923C15.2649 22.2856 14.5354 23 13.6419 23V23C12.7351 23 12 22.2649 12 21.3581V15"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12 5.5C13.2426 5.5 14.25 4.49264 14.25 3.25C14.25 2.00736 13.2426 1 12 1C10.7574 1 9.75 2.00736 9.75 3.25C9.75 4.49264 10.7574 5.5 12 5.5Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

function SvgLike(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 10H4C3.44772 10 3 10.4477 3 11V21C3 21.5523 3.44772 22 4 22H8V11C8 10.4477 7.55228 10 7 10Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8974 5.44617C14.8974 7.16671 14 7.96666 14 9H20H20.2741C20.8189 9 21.3037 9.22214 21.6236 9.61088C22.2834 10.4237 22.0535 11.7414 21.1088 12.5542C21.7686 13.367 21.5386 14.6847 20.594 15.4975C21.2538 16.3103 21.0238 17.628 20.0792 18.4408C20.739 19.2536 20.509 20.5763 19.5644 21.3891C19.1096 21.7829 18.5448 22 18 22H8V13.7231C8 8.20514 11.4513 6.13846 12.1385 2C14.2102 2 14.8974 3.72563 14.8974 5.44617Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgLikeFilled(props: Pick<SvgProps, 'style'>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.67328 10.4274L3.74143 10.945C3.20796 11.088 2.89138 11.6363 3.03432 12.1698L5.62251 21.829C5.76545 22.3625 6.31379 22.6791 6.84726 22.5361L8.77911 22.0185C9.31258 21.8755 9.62916 21.3272 9.48622 20.7937L6.89803 11.1345C6.75508 10.601 6.20675 10.2844 5.67328 10.4274Z"
        fill="#008CFF"
      />
      <path
        d="M13.0889 3.72589C13.5342 5.38781 12.8744 6.39277 13.1419 7.3909L19.2022 5.76704C19.7284 5.62604 20.2542 5.71512 20.6638 6.00782C21.5115 6.62219 21.6304 7.95447 20.9283 8.98408C21.776 9.59845 21.8949 10.9307 21.1929 11.9603C22.0405 12.5747 22.1595 13.907 21.4574 14.9366C22.305 15.5509 22.4253 16.8881 21.7232 17.9177C21.3858 18.4158 20.8964 18.7717 20.3702 18.9127L11.6769 21.242C11.1434 21.385 10.5951 21.0684 10.4521 20.5349L8.56874 13.506C7.2391 8.54368 9.57337 5.69675 9.57299 1.95808C9.57294 1.46902 9.88117 0.992556 10.3702 1.00033C11.8502 1.02385 12.7102 2.31231 13.0889 3.72589Z"
        fill="#008CFF"
      />
    </svg>
  );
}

function SvgComment(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22 12C22 16.9706 17.9097 21 12.8642 21C11.7068 21 10.5998 20.788 9.58079 20.4013C9.39449 20.3306 9.30134 20.2952 9.22727 20.2784C9.15441 20.2619 9.10167 20.2549 9.02695 20.2521C8.95099 20.2493 8.86765 20.2577 8.70097 20.2747L3.19687 20.8352C2.6721 20.8887 2.40972 20.9154 2.25494 20.8224C2.12013 20.7414 2.02831 20.606 2.00387 20.4523C1.97581 20.2759 2.10119 20.0473 2.35196 19.59L4.10997 16.3844C4.25475 16.1204 4.32714 15.9884 4.35992 15.8615C4.39231 15.7361 4.40013 15.6457 4.38978 15.5168C4.37929 15.3862 4.32114 15.2163 4.20485 14.8764C3.89582 13.9732 3.72831 13.0059 3.72831 12C3.72831 7.02944 7.81857 3 12.8642 3C17.9097 3 22 7.02944 22 12Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgShare(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 15.5V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V15.5"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M11.2539 16C11.2539 16.4142 11.5897 16.75 12.0039 16.75C12.4181 16.75 12.7539 16.4142 12.7539 16H11.2539ZM11.2539 3.5V16H12.7539V3.5H11.2539Z"
        fill={props.tint}
      />
      <path
        d="M7.75 7.24219L11.9926 2.99955L16.2353 7.24219"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgSearch(props: SvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <circle
        cx="10.5"
        cy="10.5"
        r="8.5"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="17.0607"
        y1="17"
        x2="20.9497"
        y2="20.8891"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

function SvgHorizontalDots(props: SvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 12C6.5 12.9665 5.7165 13.75 4.75 13.75C3.7835 13.75 3 12.9665 3 12C3 11.0335 3.7835 10.25 4.75 10.25C5.7165 10.25 6.5 11.0335 6.5 12ZM13.75 12C13.75 12.9665 12.9665 13.75 12 13.75C11.0335 13.75 10.25 12.9665 10.25 12C10.25 11.0335 11.0335 10.25 12 10.25C12.9665 10.25 13.75 11.0335 13.75 12ZM19.25 13.75C20.2165 13.75 21 12.9665 21 12C21 11.0335 20.2165 10.25 19.25 10.25C18.2835 10.25 17.5 11.0335 17.5 12C17.5 12.9665 18.2835 13.75 19.25 13.75Z"
        fill={props.tint}
      />
    </svg>
  );
}

function SvgVerticalDots(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6.5C11.0335 6.5 10.25 5.7165 10.25 4.75C10.25 3.7835 11.0335 3 12 3C12.9665 3 13.75 3.7835 13.75 4.75C13.75 5.7165 12.9665 6.5 12 6.5ZM12 13.75C11.0335 13.75 10.25 12.9665 10.25 12C10.25 11.0335 11.0335 10.25 12 10.25C12.9665 10.25 13.75 11.0335 13.75 12C13.75 12.9665 12.9665 13.75 12 13.75ZM10.25 19.25C10.25 20.2165 11.0335 21 12 21C12.9665 21 13.75 20.2165 13.75 19.25C13.75 18.2835 12.9665 17.5 12 17.5C11.0335 17.5 10.25 18.2835 10.25 19.25Z"
        fill={props.tint}
      />
    </svg>
  );
}

function SvgCopy(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="3" y="7" width="12" height="15" rx="2" stroke={props.tint} strokeWidth="1.5" />
      <path
        d="M9 4.34375V4C9 2.89543 9.89543 2 11 2H19C20.1046 2 21 2.89543 21 4V15C21 16.1046 20.1046 17 19 17H17.5"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

function SvgCross(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 6L12 12M12 12L6 18M12 12L6 6M12 12L18 18"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgPlus(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 12.375L4 12.375M12 4.375L12 20.375"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgEdit(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 6L18 9"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M4.57382 15.3432L3.24052 20.1355C3.13553 20.5129 3.48556 20.8589 3.86172 20.7497L8.68338 19.3489C9.00621 19.2551 9.29923 19.0824 9.53727 18.845C13.1066 15.2855 20.55 7.89245 20.55 7.89245C21.148 7.30053 21.148 6.33028 20.55 5.73227L18.2616 3.44394C17.6697 2.85202 16.7056 2.85202 16.1076 3.44394L5.08643 14.4651C4.84276 14.7087 4.66619 15.0112 4.57382 15.3432Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgDumbbell(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g stroke={props.tint} strokeWidth={1.2} fill="none" fillRule="evenodd">
        <path d="M10.891 11a.3.3 0 01.3.3v3.794l7.55.003V11.3a.3.3 0 01.3-.3h2.13a.3.3 0 01.3.3v3.798h.01v-2.46h1.7a.3.3 0 01.3.3v4.312a.3.3 0 01-.3.3h-1.7V15.1h-.01v3.789a.3.3 0 01-.3.3h-2.13a.3.3 0 01-.3-.3v-3.789h-7.55v3.789a.3.3 0 01-.3.3H8.762a.3.3 0 01-.3-.3V17.55h-1.68a.3.3 0 01-.3-.3v-4.312a.3.3 0 01.3-.3l1.68-.001V11.3a.3.3 0 01.3-.3h2.13zM21.471 12.638v4.678M11.191 12.638v4.678M8.462 12.638v4.678M18.741 12.638v4.678" />
      </g>
    </svg>
  );
}

function SvgPro(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 8.20364H3.61333C4.0734 8.20364 4.48821 8.24512 4.85778 8.32808C5.22734 8.41104 5.5441 8.5468 5.80808 8.73535C6.07205 8.9239 6.27569 9.16525 6.41899 9.45939C6.56229 9.75353 6.63394 10.108 6.63394 10.5228C6.63394 10.9678 6.55097 11.3411 6.38505 11.6428C6.21912 11.9445 5.99286 12.1896 5.70626 12.3782C5.4272 12.5592 5.09912 12.6912 4.72202 12.7741C4.34491 12.8571 3.94518 12.8986 3.52283 12.8986H2.42545V16.2133H1V8.20364ZM3.42101 11.6994C3.65481 11.6994 3.8773 11.6843 4.08848 11.6541C4.29966 11.6164 4.48821 11.5561 4.65414 11.4731C4.82007 11.3826 4.95205 11.262 5.0501 11.1111C5.14815 10.9603 5.19717 10.7642 5.19717 10.5228C5.19717 10.289 5.14815 10.1005 5.0501 9.95717C4.95205 9.80633 4.82007 9.68943 4.65414 9.60646C4.49576 9.5235 4.31097 9.47071 4.0998 9.44808C3.89616 9.41791 3.68498 9.40283 3.46626 9.40283H2.42545V11.6994H3.42101Z"
        fill={props.tint}
      />
      <path
        d="M7.78272 8.20364H10.5658C10.9429 8.20364 11.3086 8.24512 11.6631 8.32808C12.0176 8.4035 12.3306 8.53172 12.6021 8.71273C12.8812 8.89374 13.1037 9.13131 13.2696 9.42545C13.4355 9.71959 13.5185 10.0778 13.5185 10.5002C13.5185 11.0809 13.3526 11.5561 13.0207 11.9257C12.6964 12.2877 12.2514 12.5328 11.6858 12.661L13.8239 16.2133H12.1043L10.249 12.8194H9.20818V16.2133H7.78272V8.20364ZM10.3734 11.6541C10.5771 11.6541 10.7807 11.6391 10.9843 11.6089C11.188 11.5787 11.369 11.5222 11.5274 11.4392C11.6933 11.3562 11.8291 11.2393 11.9346 11.0885C12.0402 10.9301 12.093 10.7302 12.093 10.4889C12.093 10.2702 12.044 10.0929 11.946 9.95717C11.8479 9.81387 11.7235 9.70074 11.5726 9.61778C11.4218 9.53481 11.2483 9.47825 11.0522 9.44808C10.8637 9.41791 10.6789 9.40283 10.4979 9.40283H9.20818V11.6541H10.3734Z"
        fill={props.tint}
      />
      <path
        d="M14.3907 12.1859C14.3907 11.5448 14.4963 10.9678 14.7075 10.4549C14.9262 9.93454 15.2241 9.49333 15.6012 9.13131C15.9859 8.76929 16.4384 8.49024 16.9588 8.29414C17.4867 8.09805 18.0599 8 18.6784 8C19.3044 8 19.8813 8.09805 20.4093 8.29414C20.9372 8.49024 21.3935 8.76929 21.7782 9.13131C22.1628 9.49333 22.4607 9.93454 22.6719 10.4549C22.8906 10.9678 23 11.5448 23 12.1859C23 12.8118 22.8906 13.385 22.6719 13.9054C22.4607 14.4183 22.1628 14.8633 21.7782 15.2404C21.3935 15.61 20.9372 15.9003 20.4093 16.1115C19.8813 16.3151 19.3044 16.417 18.6784 16.417C18.0599 16.417 17.4867 16.3151 16.9588 16.1115C16.4384 15.9003 15.9859 15.61 15.6012 15.2404C15.2241 14.8633 14.9262 14.4183 14.7075 13.9054C14.4963 13.385 14.3907 12.8118 14.3907 12.1859ZM15.9406 12.1859C15.9406 12.6158 16.0047 13.0117 16.1329 13.3737C16.2687 13.7282 16.4572 14.0374 16.6986 14.3014C16.9475 14.5654 17.2378 14.7728 17.5697 14.9236C17.9091 15.0669 18.2824 15.1386 18.6897 15.1386C19.097 15.1386 19.4703 15.0669 19.8097 14.9236C20.1491 14.7728 20.4395 14.5654 20.6808 14.3014C20.9297 14.0374 21.1182 13.7282 21.2465 13.3737C21.3822 13.0117 21.4501 12.6158 21.4501 12.1859C21.4501 11.771 21.3822 11.3864 21.2465 11.0319C21.1182 10.6774 20.9335 10.3682 20.6921 10.1042C20.4508 9.84027 20.1604 9.63286 19.821 9.48202C19.4816 9.33118 19.1045 9.25576 18.6897 9.25576C18.2749 9.25576 17.8978 9.33118 17.5584 9.48202C17.2265 9.63286 16.9399 9.84027 16.6986 10.1042C16.4572 10.3682 16.2687 10.6774 16.1329 11.0319C16.0047 11.3864 15.9406 11.771 15.9406 12.1859Z"
        fill={props.tint}
      />
    </svg>
  );
}

function SvgReorder(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="8.5" cy="6" r="1.5" fill={props.tint} />
      <circle cx="14.5" cy="6" r="1.5" fill={props.tint} />
      <circle cx="8.5" cy="12" r="1.5" fill={props.tint} />
      <circle cx="14.5" cy="12" r="1.5" fill={props.tint} />
      <circle cx="8.5" cy="18" r="1.5" fill={props.tint} />
      <circle cx="14.5" cy="18" r="1.5" fill={props.tint} />
    </svg>
  );
}

function SvgStar(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 1.40883L15.7265 7.9464C15.7795 8.05396 15.8822 8.12853 16.0009 8.14577L23.2155 9.19412C23.5144 9.23754 23.6337 9.60488 23.4175 9.8157L18.1969 14.9045C18.111 14.9882 18.0718 15.1088 18.0921 15.2271L19.3245 22.4126C19.3756 22.7102 19.0631 22.9373 18.7958 22.7967L12.3428 19.4042C12.2366 19.3484 12.1098 19.3484 12.0036 19.4042L5.55065 22.7967C5.2833 22.9373 4.97084 22.7102 5.0219 22.4126L6.2543 15.2271C6.27457 15.1088 6.23538 14.9882 6.1495 14.9045L0.928937 9.8157C0.712647 9.60488 0.831975 9.23754 1.13088 9.19412L8.34553 8.14577C8.46424 8.12853 8.56685 8.05396 8.61991 7.9464L11.8464 1.40883C11.9801 1.13797 12.3663 1.13797 12.5 1.40883Z"
        fill={props.tint}
      />
    </svg>
  );
}

function SvgDownload(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 15.5V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V15.5"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12.7305 3C12.7305 2.58579 12.3947 2.25 11.9805 2.25C11.5663 2.25 11.2305 2.58579 11.2305 3L12.7305 3ZM12.7305 15.5L12.7305 3L11.2305 3L11.2305 15.5L12.7305 15.5Z"
        fill={props.tint}
      />
      <path
        d="M16.2344 11.7578L11.9917 16.0005L7.74909 11.7578"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgCheck(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21 6L9 19L3 12.75"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgImage(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H17C17.93 21 18.395 21 18.7765 20.8978C19.8117 20.6204 20.6204 19.8117 20.8978 18.7765C21 18.395 21 17.93 21 17M19 8V2M16 5H22M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5ZM14.99 11.9181L6.53115 19.608C6.05536 20.0406 5.81747 20.2568 5.79643 20.4442C5.77819 20.6066 5.84045 20.7676 5.96319 20.8755C6.10478 21 6.42628 21 7.06929 21H16.456C17.8951 21 18.6147 21 19.1799 20.7582C19.8894 20.4547 20.4547 19.8894 20.7582 19.1799C21 18.6147 21 17.8951 21 16.456C21 15.9717 21 15.7296 20.9471 15.5042C20.8805 15.2208 20.753 14.9554 20.5733 14.7264C20.4303 14.5442 20.2412 14.3929 19.8631 14.0905L17.0658 11.8527C16.6874 11.5499 16.4982 11.3985 16.2898 11.3451C16.1061 11.298 15.9129 11.3041 15.7325 11.3627C15.5279 11.4291 15.3486 11.5921 14.99 11.9181Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgTrash(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgTrainer(props: SvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M13 2.26953V6.40007C13 6.96012 13 7.24015 13.109 7.45406C13.2049 7.64222 13.3578 7.7952 13.546 7.89108C13.7599 8.00007 14.0399 8.00007 14.6 8.00007H18.7305M9.5 22C9.22663 22 7.8 22 7.8 22C6.11984 22 5.27976 22 4.63803 21.673C4.07354 21.3854 3.6146 20.9265 3.32698 20.362C3 19.7202 3 18.8802 3 17.2V6.8C3 5.11984 3 4.27976 3.32698 3.63803C3.6146 3.07354 4.07354 2.6146 4.63803 2.32698C5.27976 2 6.11984 2 7.8 2H11.0118C11.7455 2 12.1124 2 12.4577 2.08289C12.7638 2.15638 13.0564 2.27759 13.3249 2.44208C13.6276 2.6276 13.887 2.88703 14.4059 3.40589L17.5941 6.59411C18.113 7.11297 18.3724 7.3724 18.5579 7.67515C18.7224 7.94356 18.8436 8.2362 18.9171 8.5423C19 8.88757 19 9.25445 19 9.98822V13.5"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.73205 16L6.73205 16M15 12L7 12"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22L15.2432 18.5714L17.4054 20.8571L22 16"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 16H22V19"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgFlag(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 3V4.47654M3 4.47654L5.72668 3.79438C7.77848 3.28157 9.94604 3.5197 11.8376 4.46571L11.9439 4.51887C13.7972 5.44545 15.9167 5.6931 17.9337 5.21875L20.9951 4.4982C20.6229 7.93316 20.6246 11.3984 21 14.833L17.9347 15.5535C15.9175 16.0284 13.7976 15.7811 11.9439 14.8546L11.8376 14.8015C9.94604 13.8555 7.77848 13.6173 5.72668 14.1302L3 14.8123M3 4.47654V14.8123M3 22V14.8123"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

interface IconProps {
  type: IconType;
  tint?: string;
  style?: CSSProperties;
  dark?: string;
  light?: string;
}

export const Icon = observer((props: IconProps) => {
  const tint = props.tint ?? (props[themeState.current.name] || themeState.current.primary);

  return (
    <ThemeProvider theme={themeState.current}>
      <Icons tint={tint} {...props} style={{ width: 24, height: 24, ...props.style }} />
    </ThemeProvider>
  );
});

export type IconType =
  | 'settings'
  | 'logout'
  | 'lock'
  | 'ruler'
  | 'export'
  | 'moon'
  | 'chevron-down'
  | 'routine'
  | 'coach'
  | 'home'
  | 'profile'
  | 'new-folder'
  | 'camera'
  | 'menu'
  | 'arrow-left'
  | 'link'
  | 'exercise'
  | 'bar-chart'
  | 'developer'
  | 'beginner'
  | 'intermediate'
  | 'advanced'
  | 'muscle'
  | 'scale'
  | 'machine'
  | 'body'
  | 'like'
  | 'like-filled'
  | 'comment'
  | 'share'
  | 'search'
  | 'check'
  | 'horizontal-dots'
  | 'vertical-dots'
  | 'copy'
  | 'cross'
  | 'plus'
  | 'edit'
  | 'dumbbell'
  | 'pro'
  | 'reorder'
  | 'star'
  | 'exercise'
  | 'download'
  | 'image'
  | 'trash'
  | 'trainer'
  | 'flag';

const Icons = (props: IconProps) => {
  switch (props.type) {
    case 'settings':
      return <SvgSettings {...props} />;
    case 'logout':
      return <SvgLogout {...props} />;
    case 'lock':
      return <SvgLock {...props} />;
    case 'ruler':
      return <SvgRuler {...props} />;
    case 'export':
      return <SvgExport {...props} />;
    case 'moon':
      return <SvgMoon {...props} />;
    case 'chevron-down':
      return <SvgChevronDown {...props} />;
    case 'routine':
      return <SvgRoutine {...props} />;
    case 'coach':
      return <SvgCoach {...props} />;
    case 'home':
      return <SvgHome {...props} />;
    case 'profile':
      return <SvgProfile {...props} />;
    case 'new-folder':
      return <SvgNewFolder {...props} />;
    case 'camera':
      return <SvgCamera {...props} />;
    case 'menu':
      return <SvgMenu {...props} />;
    case 'arrow-left':
      return (
        <SvgArrowLeft
          {...props}
          style={document.documentElement.dir === 'rtl' ? { transform: 'scaleX(-1)' } : undefined}
        />
      );
    case 'link':
      return <SvgLink {...props} />;
    case 'exercise':
      return <SvgExercise {...props} />;
    case 'bar-chart':
      return <SvgBarChart {...props} />;
    case 'developer':
      return <SvgDeveloper {...props} />;
    case 'beginner':
      return <SvgBeginner {...props} />;
    case 'intermediate':
      return <SvgIntermediate {...props} />;
    case 'advanced':
      return <SvgAdvanced {...props} />;
    case 'muscle':
      return <SvgMuscle {...props} />;
    case 'scale':
      return <SvgScale {...props} />;
    case 'machine':
      return <SvgMachine {...props} />;
    case 'body':
      return <SvgBody {...props} />;
    case 'like':
      return <SvgLike {...props} />;
    case 'like-filled':
      return <SvgLikeFilled {...props} />;
    case 'comment':
      return <SvgComment {...props} />;
    case 'share':
      return <SvgShare {...props} />;
    case 'search':
      return <SvgSearch {...props} />;
    case 'check':
      return <SvgCheck {...props} />;
    case 'horizontal-dots':
      return <SvgHorizontalDots {...props} />;
    case 'vertical-dots':
      return <SvgVerticalDots {...props} />;
    case 'copy':
      return <SvgCopy {...props} />;
    case 'cross':
      return <SvgCross {...props} />;
    case 'plus':
      return <SvgPlus {...props} />;
    case 'edit':
      return <SvgEdit {...props} />;
    case 'dumbbell':
      return <SvgDumbbell {...props} />;
    case 'pro':
      return <SvgPro {...props} />;
    case 'reorder':
      return <SvgReorder {...props} />;
    case 'star':
      return <SvgStar {...props} />;
    case 'download':
      return <SvgDownload {...props} />;
    case 'exercise':
      return <SvgExercise {...props} />;
    case 'image':
      return <SvgImage {...props} />;
    case 'trash':
      return <SvgTrash {...props} />;
    case 'trainer':
      return <SvgTrainer {...props} />;
    case 'flag':
      return <SvgFlag {...props} />;
  }
};
